import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import { selectLogo } from 'app/store/fuse/settingsSlice.js';

const Root = styled('div')(({ theme }) => ({
  '& > .logo-icon': {
    transition: theme.transitions.create(['width', 'height'], {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
  '& > .badge': {
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.easeInOut,
    }),
  },
}));

function Logo() {
  const logoUrl = useSelector(selectLogo);
  return (
    <Root className='flex items-center'>
      <img className='logo-icon' width={150} src={logoUrl} alt='logo' />
    </Root>
  );
}

export default Logo;
